import React, { useState ,useEffect} from 'react';
import { Row, Container, Col, Form, Button, Modal, Spinner } from "react-bootstrap";
import Multiselect from 'multiselect-react-dropdown';
import N from '../lib/Network'
import AC from '../lib/AppConsts'
import S from '../lib/Security'
import swal from 'sweetalert'
import Loader from './Loader'
var CryptoJS = require("crypto-js");

const AddUser = ({ showUserPopup, closeModal }) =>  {
    const [employeeID,setEmployeeID]=useState('');
    const [employeeName,setEmployeeName]=useState('');
    const [emailID,setEmailID]=useState('');
    const [contactNo,setContactNo]=useState('');
    const [status,setStatus]=useState('');
    const [errors,setErrors] = useState({});
    const [roleData,setRoleData] = useState('');
    const [role,setRole] = useState([ ]);
    const [showLoader, setShowLoader] = useState(false);
    useEffect(() => {
        getKeys();
        fetchRoleData();
    },[])
    const showLoaderPopup = () => { setShowLoader(true) }
    const closeLoader = () => { setShowLoader(false) }
    function getKeys(){
        if(S.getPrivateKey() == '' && S.getPublicKey() == ''){
          N.getRSAApi('/getRsaKeys')
          .then(res => {
              let resObj = JSON.parse(res.data);
              let resJson = JSON.parse(resObj.responseJson);
              if(resJson.privateKey && resJson.publicKey){
                  let newKey = CryptoJS.enc.Utf8.parse('NexStepPrivacy@#');
                  // Decrypt
                  var privateKeyBytes = CryptoJS.AES.decrypt(resJson.privateKey, newKey, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7});
                  S.privateKey = privateKeyBytes.toString(CryptoJS.enc.Utf8);
      
                  var publicKeyBytes = CryptoJS.AES.decrypt(resJson.publicKey, newKey, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7});
                  S.publicKey = publicKeyBytes.toString(CryptoJS.enc.Utf8);
              }
          })
          .catch(err => {
              console.log("Error : "+err);
          });
        }
      }
    const current = new Date();
    const date = `${current.getDate()}/${current.getMonth()+1}/${current.getFullYear()}`;
    const closePopup = () => { closeModal(); clearState(); }
    const fetchRoleData = () => {
         N.getApi('getRoles')
           .then(res => {
            var response = S.getDecryptedJSON(res);
            setRoleData(JSON.parse(response.responseJson))
           })
      }
    const validateForm = () => {
        let formIsValid = true;
        let er = {};
        var alphaNumeric = new RegExp(/^[A-Za-z0-9]+$/i);
        var alphawithspace = new RegExp(/^[A-Za-z ]+$/i);
        var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
        var PhPattern = new RegExp(/^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/i);
        if(employeeID ==="" || employeeID.length<=0){
            er["employeeID"] = "Employee ID cannot be empty";
          formIsValid= false;
        }else if(!alphaNumeric.test(employeeID)){
            er["employeeID"] = "Special character not allowed in Employee ID";
          formIsValid= false;
        }if(employeeName ==="" || employeeName.length<=0){
            er["employeeName"] = "Employee Name cannot be empty";
            formIsValid= false;
        }else if(!alphawithspace.test(employeeName)){
            er["employeeName"] = "Special character and Numeric value are not allowed in Employee Name";
          formIsValid= false;
        }
        if(emailID ==="" || emailID.length<=0){
            er["emailID"] = "Email ID cannot be empty";
            formIsValid= false;
        }else if(!pattern.test(emailID)){
            er["emailID"] = "Please enter valid email address.";
            formIsValid= false;
        }
        if(contactNo ===""){
            er["contactNo"] = "Contact No cannot be empty";
            formIsValid= false;
            
        }else if(!PhPattern.test(contactNo)){
            er["contactNo"] = "Please enter valid Contact No ";
            formIsValid= false;
        }else if(contactNo.length!= 10){
            er["contactNo"] = "Please enter valid Contact No";
            formIsValid= false;
        }
        if(status ==="" || status ===undefined){
            er["status"] = "Status cannot be empty";
            formIsValid= false;
        }
        if(role.length<=0){
            er["role"] = "Select at least One Role";
            formIsValid= false;
        }
        setErrors(er);
        return formIsValid;
    }
    const validateEmpName = (event) =>{
        var employeenameValidate = {
            empName: event.target.value.trim(),
            userId:"0"
        }
        if(employeenameValidate.empName.length != 0){
            N.postApi('validateManageUser', employeenameValidate)
            .then(res => {
                var response = S.getDecryptedJSON(res);
                if(response.responseStatus != AC.STATUS_SUCCESS){
                    var msg =JSON.parse(response.responseJson)
                    if(msg != ""){
                        let er = {};
                        er["employeeName"] = msg.Payload.Message;
                        setErrors(er);
                        event.target.value = "";
                        setEmployeeName();
                }}  
            })
            .catch(err => {
                console.log("Error : " + err);
            });
        }
    }
    const validateEmpID = (event) =>{
        var employeecodeValidate = {
            empCode: event.target.value.trim(),
            userId:"0"
        }
        if(employeecodeValidate.empCode.length != 0){
            N.postApi('validateManageUser', employeecodeValidate)
            .then(res => {
                var response = S.getDecryptedJSON(res);
                if(response.responseStatus != AC.STATUS_SUCCESS){
                    var msg =JSON.parse(response.responseJson)
                    if(msg != ""){
                        let er = {};
                        er["employeeID"] = msg.Payload.Message;
                        setErrors(er);
                        event.target.value = "";
                        setEmployeeID();
                }}  
            })
            .catch(err => {
                console.log("Error : " + err);
            });
        }
    }
    const validateEmpEmail = (event) =>{
        var employeeEmailValidate = {
            empEmail: event.target.value.trim(),
            userId:"0"
        }
        if(employeeEmailValidate.empEmail.length != 0){
            N.postApi('validateManageUser', employeeEmailValidate)
            .then(res => {
                var response = S.getDecryptedJSON(res);
                if(response.responseStatus != AC.STATUS_SUCCESS){
                var msg =JSON.parse(response.responseJson)
                if(msg != ""){
                    let er = {};
                    er["emailID"] = msg.Payload.Message;
                    setErrors(er);
                    event.target.value = "";
                    setEmailID()
            }}
            
                
            })
            .catch(err => {
                console.log("Error : " + err);
            });
        }
    }
    const handleChange = (event) => {
        if (event.target.name === 'employeeID') {
            errors["employeeID"] ="";
            setEmployeeID( event.target.value );
        }
        if (event.target.name === 'employeeName') {
            errors["employeeName"] ="";
            setEmployeeName( event.target.value );
        }
        if (event.target.name === 'emailID') {
            errors["emailID"] ="";
            setEmailID( event.target.value );
        }
        if (event.target.name === 'contactNo') {
            errors["contactNo"] ="";
            setContactNo( event.target.value );
        }
        if (event.target.name === 'status') {
            if(event.target.value != 0){
                errors["status"] ="";
                setStatus( event.target.value )
            }else{
            errors["status"] ="";
            setStatus();
            }
        }
        
    }
    const onSelect =  (data) => { errors["role"] = ""; setRole(data); }
    const onRemove =  (data) => { errors["role"] = ""; setRole(data); }
    const saveUserDetails = (event) => {
        event.preventDefault()
        let isThisValidForm = false;
        if(validateForm()){
           isThisValidForm = true;
        }
        if(isThisValidForm){
            showLoaderPopup();
        var TabObj = {
            role :role,
            userStatus :status,
            empName :employeeName,
            empCode : employeeID,
            empEmail : emailID,
            contactNo : contactNo,
            action : AC.ACTION_SAVE,
            createdById : localStorage.getItem("userId"),
            userCreatedDate : date,
            userId : "0",
        }
            return N.postApi('createUser',TabObj)
            .then(res => {
                var response = S.getDecryptedJSON(res);
                if(response.responseStatus === AC.STATUS_SUCCESS){
                    closeLoader();
                    swal("Success!", "Record Saved Suceesfully", "success", { buttons: false,timer: 2000,});
                    closePopup();
                    setTimeout(() => {
                        window.location.reload(true); 
                    }, 2000);
                }else{
                    closeLoader();
                    swal("Error!", "Record Not Saved", "warning", { buttons: false,timer: 2000,});
                    document.getElementById("saveUser").disabled = false;
                }
            })
            .catch(err => {
                console.log("Error : " + err);
            });
        }
    }
    const clearState = () =>{setRole([]);setStatus('');setEmployeeName('');setEmployeeID('');setEmailID('');setContactNo('');setErrors({});}
    return (
        <Modal id="addUser" show={showUserPopup} animation={true} size="xl">
            <Modal.Header closeButton onClick={closePopup}>
                <Modal.Title><h5 className="headerTitle">Create User</h5></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Container fluid>
                    <Row>
                        <Col xs={6} md={3} lg={3}>
                            <Form.Group className="mb-3">
                                <Form.Label>Employee ID</Form.Label>
                                <Form.Control  name="employeeID" type="text" className="form-control" placeholder="Enter Employee ID" onChange={handleChange} onBlur={validateEmpID}/>
                                <div className="invalid-feedback">{errors["employeeID"]}</div>
                            </Form.Group>
                        </Col>
                        <Col xs={6} md={3} lg={3}>
                            <Form.Group className="mb-3">
                                <Form.Label>Employee Name</Form.Label>
                                <Form.Control  type="text" name="employeeName" className="form-control" placeholder="Enter Employee Name" onChange={handleChange} onBlur={validateEmpName}/>
                                <div className="invalid-feedback">{errors["employeeName"]}</div>
                            </Form.Group>
                        </Col>
                        <Col xs={6} md={3} lg={3}>
                            <Form.Group className="mb-3">
                                <Form.Label>Email ID</Form.Label>
                                <Form.Control  type="text" name="emailID" className="form-control" placeholder="Enter Email ID" onChange={handleChange} onBlur={validateEmpEmail}/>
                                <div className="invalid-feedback">{errors["emailID"]}</div>
                            </Form.Group>
                        </Col>
                        <Col xs={6} md={3} lg={3}>
                            <Form.Group className="mb-3">
                                <Form.Label>Contact No.</Form.Label>
                                <Form.Control  type="number" name="contactNo" className="form-control" placeholder="Enter Contact No." onChange={handleChange}/>
                                <div className="invalid-feedback">{errors["contactNo"]}</div>
                            </Form.Group>
                        </Col>
                        <Col xs={6} md={3} lg={3}>
                            <Form.Group className="mb-3">
                                <Form.Label>Status</Form.Label>
                                <Form.Select name="status" className="form-control"  onChange={handleChange} >
                                    <option value="0" >- Select User Status -</option>
                                    <option value="Y">Active</option>
                                    <option value="N">Inactive</option>
                                </Form.Select>
                                <div className="invalid-feedback">{errors["status"]}</div>
                            </Form.Group>
                        </Col>
                        <Col xs={6} md={3} lg={3}>
                            <Form.Group className="mb-3">
                                <Form.Label>Roles</Form.Label>  
                                <Multiselect
                                    name='role'
                                    options={roleData?.Payload?.RoleList}
                                    displayValue='roleName'
                                    onSelect={onSelect}
                                    onRemove={onRemove}
                                    />
                                    <div className="invalid-feedback">{errors["role"]}</div>
                            </Form.Group>
                        </Col>
                    </Row>
                </Container>
                <Loader showLoader={showLoader} />
            </Modal.Body>
            <Modal.Footer className='text-center'>
                <Button className="btn btn-sm btn-danger shadow-sm" onClick={closePopup}> Cancel </Button>
                <Button type="button" className="btn btn-sm btn-primary shadow-sm" id="saveUser" onClick={saveUserDetails}> Save & Submit </Button>
            </Modal.Footer>
        </Modal>
    )
}
export default AddUser;